export default {
  // 微信支付签名获取
  async getWXSign(parmas) {
    let actiontype = "OrderService_GetPayUrlHandler";
    return await this.fetch(actiontype, parmas);
  },
  // 美团酒店模块
  // 获取酒店地址
  async getHotelCity(params) {
    let actiontype = "HotelService_GetCityList";
    return await this.fetch(actiontype, params);
  },
  // 获取酒店列表
  async getHotelList(params) {
    let actiontype = "HotelService_GetHotelList";
    return await this.fetch(actiontype, params);
  },
  // 获取酒店详情
  async getHotelDetail(params) {
    let actiontype = "HotelService_GetHotelDetail";
    return await this.fetch(actiontype, params);
  },
  // 获取酒店支付链接信息
  async getHotelPayInfo(params) {
    let actiontype = "getPayUrl";
    return await this.fetch(actiontype, params);
  },
  // 查询酒店退款详情
  async lookHotelRefund(params) {
    let actiontype = "HotelService_SelectCancelOrderDetail";
    return await this.fetch(actiontype, params);
  },
  // 查询酒店订单详情
  async lookHotelOrderDetail(params) {
    let actiontype = "HotelService_SelectHotelOrderDetail";
    return await this.fetch(actiontype, params);
  },
  // 查询酒店订单列表
  async lookHotelOrderList(params) {
    let actiontype = "HotelService_SelectHotelOrderList";
    return await this.fetch(actiontype, params);
  },
  // 提交酒店订单
  async submitHotelOrder(params) {
    let actiontype = "HotelService_SubmitHotelOrder";
    return await this.fetch(actiontype, params);
  },
  // 酒店退订
  async cancelHotelOrder(params) {
    let actiontype = "HotelService_CancelHotelOrder";
    return await this.fetch(actiontype, params);
  },
  // 房态信息
  async getHotelStatus(params) {
    let actiontype = "HotelService_GetHotelGoodsStatus";
    return await this.fetch(actiontype, params);
  },
  // 呼叫中心支付
  async callCenterPay(params) {
    let actiontype = "Manage_GetManagePayDetail";
    return await this.fetch(actiontype, params);
  },
  // 获取支付链接
  async getPayUrl(params) {
    let actiontype = "OrderService_GetPayUrlHandler";
    return await this.fetch(actiontype, params);
  },
  // 国际票模块
  // 获取所有国家
  async getAllCountry(params) {
    let actiontype = "FlightService_GetAllCountryInfo";
    return await this.fetch(actiontype, params);
  },
  // 添加常用乘机人
  async addCommonUseP(params) {
    let actiontype = "AccountService_FrequentFlierAddHandler";
    return await this.fetch(actiontype, params);
  },
  // 修改常用乘机人
  async amendPassenger(params) {
    let actiontype = "AccountService_FrequentFlierModifyHandler";
    return await this.fetch(actiontype, params);
  },
  // 美食服务
  // 美食详情
  async getFoodDetail(params) {
    let actiontype = "FoodService_GetMealDetail";
    return await this.fetch(actiontype, params);
  },
  // 选座
  async getFlightSeatMapHandler(params) {
    let actiontype = "FlightService_GetFlightSeatMapHandler";
    return await this.fetch(actiontype, params);
  },
  // 判断该航班是否可以选座
  async checkCanSelectSeat(params) {
    let actiontype = "FlightService_CheckCanChooseSeat";
    return await this.fetch(actiontype, params, "no");
  },
  // 机＋X 行李
  // 获取行李列表

  // 获取行李的价格
  async getLuggagePrice(params) {
    let actiontype = "PrepaidLuggage_GetPriceInfos";
    return await this.fetch(actiontype, params);
  },
  async createdOrder(params) {
    let actiontype = "OrderService_CreateOrderHandler";
    return await this.fetch(actiontype, params, false, 20000);
  },
  // 判断该航班是否可以购买行李
  async checkCanBuyLuggage(params) {
    let actiontype = "PrepaidLuggage_CheckCanByPrepaidLuggage";
    return await this.fetch(actiontype, params);
  },
  // 预付费行李模块
  // 订单列表
  async getOrderList(params) {
    let actiontype = "ExcessLuggageService_GetMyLuggageOrderList";
    return await this.fetch(actiontype, params);
  },
  // // 根据票号证件号获取购票信息
  // async getBuyInfoByTicket(params) {
  //     let actiontype = 'PrepaidLuggage_GetFlightInfos'
  //     return await this.fetch(actiontype, params)
  // },
  // 根据票号证件号获取购票信息
  async getFlightInfosNew(params) {
    let actiontype = "PrepaidLuggage_getConnectFlightSegmentInfos";
    return await this.fetch(actiontype, params);
  },
  // 预付费行李订单列表
  async getLuggageList(params) {
    let actiontype = "PrepaidLuggage_GetMyLuggageOrderList";
    return await this.fetch(actiontype, params);
  },
  // 预付费行李是否可购买
  async checkLuggagePurchase(params, type) {
    let actiontype = "checkCanByPrepaidLuggageNew";
    return await this.fetch(actiontype, params, type);
  },
  // 根据航线查询行李价格信息
  async getLuggagePriceByFit(params) {
    let actiontype = "PrepaidLuggage_GetPriceInfos";
    return await this.fetch(actiontype, params);
  },
  // 提交行李订单-创单
  async creatLuggageOrder(params) {
    let actiontype = "PrepaidLuggage_OrderCreate_CreateMultipleOrder";
    return await this.fetch(actiontype, params);
  },
  // 提交行李订单 单独购买
  async submitLuggageOrder(params) {
    let actiontype = "PrepaidLuggage_OrderCreate_CreateSingleOrder";
    return await this.fetch(actiontype, params);
  },
  // 单独退行李订单
  async refuseLuggageOrder(params) {
    let actiontype = "PrepaidLuggage_OrderRefund_CreateSingleRefundOrder";
    return await this.fetch(actiontype, params);
  },
  // 行李详情 delete
  async getLuggageDetail(params) {
    let actiontype = "PrepaidLuggage_GetUIOrderDetail";
    return await this.fetch(actiontype, params);
  },
  // 行李-查单
  async getLuggageInfo(params) {
    let actiontype = "getSingleUIOrderDetailNew";
    return await this.fetch(actiontype, params);
  },
  // 取消行李订单
  async cancelLuggageOrder(params) {
    let actiontype = "OrderService_OrderCancelHandler";
    return await this.fetch(actiontype, params);
  },
  // 呼叫中心保险支付详情
  async callCenterInsPay(params) {
    let actiontype = "Manage_GetInsuranceOrderDetailByToken";
    return await this.fetch(actiontype, params);
  },
  // 获取保险支付链接
  async getInsPayUrl(params) {
    let actiontype = "Manage_GetInsurancePayUrl";
    return await this.fetch(actiontype, params);
  },
  // 改期
  // 校验是否可以改期
  async checkIsCanChangeDate(params) {
    let actiontype = "OrderService_CheckIsCanChangeHandler";
    return await this.fetch(actiontype, params);
  },
  // 订单详情
  async getOrderDetail(params) {
    let actiontype = "OrderService_OrderDetialHandler";
    return await this.fetch(actiontype, params);
  },
  // 订单详情三端
  async getMyAnonymOrderDetail(params) {
    let actiontype = "getMyAnonymOrderDetail";
    return await this.fetch(actiontype, params);
  },
  // 改期航班查询
  async changeFlightDateSearch(params) {
    // let actiontype = 'OrderService_GetChangeFlightsHandler'
    let actiontype = "searchChangeConnectFlights";
    return await this.fetch(actiontype, params);
  },
  // 提交改期订单
  async submitChangeDateOrder(params) {
    let actiontype = "Manage_TicketChangeHandler";
    return await this.fetch(actiontype, params);
  },
  // 获取退单要支付费用
  async getRefundTicketPay(params) {
    let actiontype = "OrderService_GetRefundFees";
    return await this.fetch(actiontype, params);
  },
  // 退票接口
  async submitRefundOrder(params) {
    let actiontype = "OrderService_RefundOrderHandler";
    return await this.fetch(actiontype, params);
  },
  // 非自愿改期自动改变支付状态
  async nonvoluntaryChangePay(params) {
    let actiontype = "OrderService_ChangePayStatus";
    return await this.fetch(actiontype, params);
  },
  async changePayStatusByToken(params) {
    let actiontype = "OrderService_ChangePayStatusByToken";
    return await this.fetch(actiontype, params);
  },
  // token获取支付详情
  async getReceiptOrderDetailByToken(params) {
    let actiontype = "getReceiptOrderDetailByToken";
    return await this.fetch(actiontype, params);
  },
  //获取支付链接
  async getReceiptPayUrl(params) {
    let actiontype = "getReceiptPayUrl";
    return await this.fetch(actiontype, params);
  },
  // 取消订单
  async cancelReceiptOrder(params) {
    let actiontype = "cancelReceiptOrder";
    return await this.fetch(actiontype, params);
  },
  // 退行程单
  async refundItineraryOrderHandler(params) {
    let actiontype = "OrderService_RefundItineraryOrderHandler";
    return await this.fetch(actiontype, params);
  },
  // 多人值机
  // 添加同行人校验
  async checkPeers(params) {
    let actiontype = "OrderService_partnersAdd";
    return await this.fetch(actiontype, params);
  },
  // 多人值机提交
  async submitMorePerCheckIn(params) {
    let actiontype = "OrderService_multiCheckIn";
    return await this.fetch(actiontype, params);
  },
  // 添加到卡包
  async addCardHolder(params) {
    let actiontype = "OrderService_cardHolderAdd";
    return await this.fetch(actiontype, params);
  },
  // 查看登机牌的时候查询同行人信息
  async getPeersInfo(params) {
    let actiontype = "OrderService_getPartnerInfo";
    return await this.fetch(actiontype, params);
  },
  // 通过token获取登机牌信息
  async getTicketByToken(params) {
    let actiontype = "OrderService_QrBoardingPassInfo";
    return await this.fetch(actiontype, params);
  },
  // 正常获取登机牌信息
  async getTicketNomal(params) {
    let actiontype = "OrderService_QrBoardingPassHandler";
    return await this.fetch(actiontype, params);
  },
  // 正常获取登机牌信息(new)
  async getTicketBoardingPass(params, type) {
    let actiontype = "SeatChoose_QrBoardingPassHandler";
    return await this.fetch(actiontype, params, type);
  },
  // 取消值机
  async cancelCheckIn(params) {
    let actiontype = "OrderService_CancelCheckInHandler";
    return await this.fetch(actiontype, params);
  },
  // 获取微信签名
  async getSignature(params) {
    let actiontype = "FlightChangeService_GetSignature";
    return await this.fetch(actiontype, params);
  },
  // 申请改期入口
  async getSaleOrderTidByTicketNo(params) {
    let actiontype = "getSaleOrderTidByTicketNo";
    return await this.fetch(actiontype, params);
  },
  // 获取用户信息
  async getUserInfo(params) {
    let actiontype = "AccountService_UserDetailInfoHandler";
    return await this.fetch(actiontype, params);
  },
  // 校验验证码
  async checkPhoneCode(params) {
    let actiontype = "AccountService_checkPhoneVerifyCode";
    return await this.fetch(actiontype, params);
  },
  // 获取验证码
  async getPhoneCode(params, type) {
    let actiontype = "AccountService_GetPhoneVerifyCodeHandler";
    return await this.fetch(actiontype, params, type);
  },
  // 获取航段信息（要验证码）
  async searchByMsg(params, type) {
    let actiontype = "SeatChoose_GetTravelSegmentInfo";
    return await this.fetch(actiontype, params, type);
  },
  // 不需要验证码的
  async getFlightInfoList(params, type) {
    let actiontype = "SeatChoose_GetTravelSegmentInfo2";
    return await this.fetch(actiontype, params, type);
  },
  // 拉取座位图
  async getSeatList(params, type) {
    let actiontype = "SeatChoose_GetRemitedSeatMap";
    return await this.fetch(actiontype, params, type);
  },
  // 获取我的选座订单列表
  async getMySeatlist(params, type) {
    let actiontype = "SeatChoose_GetMySeatOrders";
    return await this.fetch(actiontype, params, type);
  },
  // 获取同行人信息
  async getPeerInfo(params, type) {
    let actiontype = "SeatChoose_CheckCanTogether";
    return await this.fetch(actiontype, params, type);
  },
  // 单独创建选座订单
  async createSeatOrder(params, type) {
    let actiontype = "SeatChoose_CreateSingleSeatOrder";
    return await this.fetch(actiontype, params, type);
  },
  // 取消选座的接口
  async cancelSeat(params, type) {
    let actiontype = "SeatChoose_CancelSingleSeatOrders";
    return await this.fetch(actiontype, params, type);
  },
  // 获取选座详情
  async getSeatDetail(params, type) {
    let actiontype = "SeatChoose_GetCabinSeatOrderInfo";
    return await this.fetch(actiontype, params, type);
  },
  // 优惠券模块
  // 获取优惠券列表
  async getCouponList(params) {
    let actiontype = "CouponService_selectMyCoupon";
    return await this.fetch(actiontype, params);
  },
  // 获取可使用的优惠券
  async selectCouponList(params) {
    // let actiontype = 'CouponService_selectCouponList'
    let actiontype = "CouponService_queryAvailableCouponList";
    return await this.fetch(actiontype, params);
  },
  // 判断那个乘客
  async checkinPsgCoupon(params) {
    let actiontype = "CouponService_checkUserCertInfo";
    return await this.fetch(actiontype, params);
  },
  // 获取邮寄信息
  async getEMS(params) {
    let actiontype = "FlightService_GetExpressExpensesHandler";
    return await this.fetch(actiontype, params);
  },
  // 获取机+x图片url
  async getXUrl(params) {
    let actiontype = "ArticleService_getImageUrlInfo";
    return await this.fetch(actiontype, params);
  },
  // 获取特价机票列表
  async getSpecialTicketsList(parmas) {
    let actiontype = "FlightService_SpecialOfferTicketsHandler";
    return await this.fetch(actiontype, parmas);
  },
  // 获取机+酒店列表
  async getFlightXProductDetail(params) {
    let actiontype = "getFlightXProductDetail";
    return await this.fetch(actiontype, params);
  },
  // 购票后选座
  async getAfterBuySeat(params) {
    let actiontype = "OrderService_SeatMapHandler";
    return await this.fetch(actiontype, params);
  },
  // 查询优惠券
  async inquiryCoupon(params, type) {
    let actiontype = "CouponService_selectCouponByTarget";
    return await this.fetch(actiontype, params, type);
  },
  // 领取优惠券
  async getAllCoupon(params, type) {
    // let actiontype = 'CouponService_receiveCoupon';
    let actiontype = "CouponService_memberReceiveCoupon";
    return await this.fetch(actiontype, params, type);
  },
  // 手机验证码登录
  async mobileLogin(params) {
    let actiontype = "AccountService_MobileLoginHandler";
    return await this.fetch(actiontype, params);
  },
  // 阿里那回调url
  async getAliPayCardUrl(params) {
    let actiontype = "getAlipayCardCallBack";
    return await this.fetch(actiontype, params);
  },
  // 阿里跳转回调
  async authOpendCardCallBack(params) {
    let actiontype = "authOpendCardCallBack";
    return await this.fetch(actiontype, params);
  },
  // 图片验证码
  async getImageVerifyCode(params) {
    let actiontype = "AccountService_GetImageVerifyCodeHandler";
    return await this.fetch(actiontype, params);
  },
  // 账号登录
  async userLogin(params) {
    let actiontype = "AccountService_UserLoginHandler";
    return await this.fetch(actiontype, params);
  },
  //问卷提交
  async sendQuestionnaire(params) {
    let actiontype = "ServiceQualityService_FinishExamHandler";
    return await this.fetch(actiontype, params);
  },
  // 获取餐食航班
  async getFoodFlight(params) {
    let actiontype = "FoodService_selectFlightFoods";
    return await this.fetch(actiontype, params);
  },
  // 同行人校验
  async checkFoodPeer(params) {
    let actiontype = "FoodService_checkParnterInfo";
    return await this.fetch(actiontype, params);
  },
  // 单独购买美食生单
  async createFoodOrder(params) {
    let actiontype = "orderCreate";
    return await this.fetch(actiontype, params);
  },
  // 单独购买美食订单详情
  async getFoodOrderDetail(params) {
    let actiontype = "orderDetails";
    return await this.fetch(actiontype, params);
  },
  // 获取单独购买美食列表
  async getMealOrderList(params) {
    let actiontype = "orderList";
    return await this.fetch(actiontype, params);
  },
  // 调起微信支付
  async getOrderPayUrl(params) {
    let actiontype = "orderPayUrl";
    return await this.fetch(actiontype, params);
  },
  // 退款订单列表
  async getRefundList(params) {
    let actiontype = "refundList";
    return await this.fetch(actiontype, params);
  },
  // 申请单独餐食退款
  async orderRefund(params) {
    let actiontype = "orderRefund";
    return await this.fetch(actiontype, params);
  },
  // 会员接口
  // 会员认证
  async memberAuth(params) {
    let actiontype = "AccountService_memberAuth";
    return await this.fetch(actiontype, params);
  },
  // 提交梦想信息
  async submitDreamInfo(params) {
    let actiontype = "activeRegistry";
    return await this.fetch(actiontype, params);
  },
  //查看记录
  async lookDreamInfo(params) {
    let actiontype = "selectActiveRegistry";
    return await this.fetch(actiontype, params);
  },
  // 判断是否登录
  async isLoginJudge(params, type) {
    let actiontype = "AccountService_UserDetailInfoHandler";
    return await this.fetch(actiontype, params, type);
  },
  // 休息列表查询
  async searchRestList(params) {
    let actiontype = "Platlounge_LoungeList";
    return await this.fetch(actiontype, params);
  },
  // 休息室详情
  async getRestDetail(params) {
    let actiontype = "Platlounge_QueryloungeDetail";
    return await this.fetch(actiontype, params);
  },
  // 创建休息室订单
  async createRestOrder(params) {
    let actiontype = "orderCreate";
    return await this.fetch(actiontype, params);
  },
  // 休息室订单详情
  async getRestOrderDetail(params) {
    let actiontype = "orderDetails";
    return await this.fetch(actiontype, params);
  },
  // 休息室订单取消
  async restOrderCancel(params) {
    let actiontype = "orderCancel";
    return await this.fetch(actiontype, params);
  },
  // 休息室改签
  async restChangeDate(params) {
    let actiontype = "loungeOrderChangeDate";
    return await this.fetch(actiontype, params);
  },
  // 休息室申请退款
  async restRefund(params) {
    let actiontype = "orderRefund";
    return await this.fetch(actiontype, params);
  },
  // 休息室订单列表
  async restOrderList(params) {
    let actiontype = "orderList";
    return await this.fetch(actiontype, params);
  },
  // 搜航班列表
  async getFlightList(params) {
    let actiontype = "FlightService_FlightSearchHandler";
    return await this.fetch(actiontype, params);
  },
  // 获取低价日历
  async getLowPriceList(params) {
    let actiontype = "FlightService_LowPriceHandler";
    return await this.fetch(actiontype, params);
  },
  // 获取常用乘机人列表
  async getPsgList(params) {
    let actiontype = "AccountService_FrequentFlierListHandler";
    return await this.fetch(actiontype, params);
  },
  // 删除乘机人
  async deletPsg(params) {
    let actiontype = "AccountService_FrequentFlierDeleteHandler";
    return await this.fetch(actiontype, params);
  },
  // 新订单详情
  async getNewOrderDetail(params) {
    let actiontype = "newOrderDetail";
    //          let actiontype = 'FlashSale/OrderDetail'
    return await this.fetch(actiontype, params);
  },
  // 获取邮寄行程单列表
  async getItineraryOrderList(params) {
    let actiontype = "OrderService_ItineraryOrderHandler";
    return await this.fetch(actiontype, params);
  },
  // 获取邮寄行程单
  async getItinerary(params) {
    let actiontype = "OrderService_GetItineraryOrderDetailHandler";
    return await this.fetch(actiontype, params);
  },
  //获取新闻
  async getArticleList(parmas) {
    let actiontype = "ArticleService_B2C_GetArticleListHandler";
    return await this.fetch(actiontype, parmas);
  },
  //获取新闻详情
  async getArticleInfo(parmas) {
    let actiontype = "ArticleService_B2C_GetArticleInfoByTidHandler";
    return await this.fetch(actiontype, parmas);
  },
  //获取新闻详情
  async getOrderList(parmas) {
    let actiontype = "OrderService_OrderListHandler";
    return await this.fetch(actiontype, parmas);
  },
  //获取早鸟特惠票
  async getbirldSaleList(parmas) {
    let actiontype = "ManageService_GetEarlyBirdTicketList";
    return await this.fetch(actiontype, parmas);
  },
  // 特价机票和早年票开关
  async getEarlyBirdTicketSwitch(params) {
    let actiontype = "ManageService_GetEarlyBirdTicketSwitch";
    return await this.fetch(actiontype, params);
  },
  //获取休息室订单信息
  async getPayAmountByToken(params) {
    let actiontype = "ex_getPayAmountByToken";
    return await this.fetch(actiontype, params);
  },
  //获取餐食订单信息
  async getPaymentMealOrderDetails(params) {
    let actiontype = "getOrderDetails";
    return await this.fetch(actiontype, params);
  },
  //客票验真
  async TicketCheck(params) {
    let actiontype = "OrderService_TicketCheckHandler";
    return await this.fetch(actiontype, params);
  },
  // 订票联系人获取
  async getContactInfoByUserId(params) {
    let actiontype = "getContactInfoByUserId";
    return await this.fetch(actiontype, params);
  },
  // 值机柜台获取
  async getFlightCounters(params) {
    let actiontype = "getFlightCounters";
    return await this.fetch(actiontype, params);
  },
  // 白屏支付链接获取微信短链
  async generateWechatAppletLink(params) {
    let actiontype = "generateWechatAppletLink";
    return await this.fetch(actiontype, params);
  },
  // 无陪儿童申请书填写
  async fillNoAdultPassenger(params) {
    let actiontype = "/NoAdultCheck/client/noAdultPassenger/fill";
    return await this.fetch(actiontype, params);
  },
  // 呼叫中心支付,获取校验
  async getCallCenterSafeCheck(params) {
    let actiontype =
      "/OrderCreate/clientNoLogin/passengerNameVerify/getMaskedInfo";
    return await this.fetch(actiontype, params);
  },
  // 呼叫中心支付,校验
  async callCenterSafeCheckVerify(params) {
    let actiontype = "/OrderCreate/clientNoLogin/passengerNameVerify/check";
    return await this.fetch(actiontype, params);
  }
};



// WEBPACK FOOTER //
// ./src/interfaces/modules/before.js